// Count for the Academy sidebar pill: lessons that shipped after the officer
// joined (and within the last 90 days, so a long-time account is not greeted
// with a two-digit number) that they have not opened yet. 0 until the user
// and the progress are both known, so the pill never flashes.
import { useEffect, useMemo } from "react";
import { useAuth } from "../context/AuthContext";
import { ALL_LESSONS } from "./catalog";
import { loadAcademyProgress, useAcademyProgressStore } from "./progress";

export const ACADEMY_BADGE_WINDOW_DAYS = 90;

export function countUnseenNewLessons(
  lessons: { id: string; releasedAt: string }[],
  createdAt: string | Date | null | undefined,
  viewed: Record<string, string> | undefined,
  now = Date.now(),
): number {
  const joined = createdAt ? new Date(createdAt).getTime() : NaN;
  if (!Number.isFinite(joined)) return 0;
  const windowStart = now - ACADEMY_BADGE_WINDOW_DAYS * 86400000;
  return lessons.filter((l) => {
    const released = Date.parse(l.releasedAt);
    return Number.isFinite(released) && released > joined && released >= windowStart && !viewed?.[l.id];
  }).length;
}

export function useAcademyBadge(): number {
  const { user } = useAuth();
  const { progress, loaded } = useAcademyProgressStore();

  useEffect(() => {
    if (user) loadAcademyProgress();
  }, [user]);

  return useMemo(() => {
    if (!user || !loaded) return 0;
    return countUnseenNewLessons(ALL_LESSONS, (user as any).created_at, progress.viewed);
  }, [user, loaded, progress.viewed]);
}
